<template>
    <div id="book-list-container">
        <div class="listing">
            <div class="heading">
                <div class="cell cell-thumb"></div>
                <div class="main-meta-wrapper">
                    <div class="cell cell-ebookseriesname"> {{ i18n.t("label_series")}}</div>
                    <div class="cell cell-ebookname"> {{ i18n.t("label_book")}}</div>
                    <div class="cell cell-ebookmodulename">{{ i18n.t("label_chapter")}}</div>
                    <div class="cell cell-publisher">{{ i18n.t("label_publisher")}} </div>
                </div>
            </div>
            <template v-for="(book, index) in ebooklist">
                <template v-for="(module, moduleindex) in book.ebooks"
                >
                    <router-link  class="row"  :to="{ name: 'Reader', query: {ebookcode:  module.ebookcode} }"   v-show="isShowBookEntry(book) && isShowModule(book, module.ebookmodulename)">
                        <div class="row" v-show="isShowBookEntry(book) && isShowModule(book, module.ebookmodulename)">
                            <div class="cell cell-thumb">
                                <img :src="getEbookCoverURL(book.ebooks[0].ebookcover2url, book.ebooks[0].ebookcode)"
                                     class="cover-img"
                                     onerror="this.onerror=null;this.style.display='none'; this.previousSibling.style.display='block'"
                                >
                            </div>
                            <div class="main-meta-wrapper">
                                <div class="cell cell-ebookseriesname">
                                    <div class="cell-wrapper">
                                        <div class="cell-heading"> {{ i18n.t("label_series")}}</div>
                                        <div class="cell-content">{{ book.ebookseriesname }}</div>
                                    </div>
                                </div>
                                <div class="cell cell-ebookname">
                                    <div class="cell-wrapper">
                                        <div class="cell-heading"> {{ i18n.t("label_book")}}</div>
                                        <div class="cell-content">{{ book.ebookname }}</div>
                                    </div>
                                </div>
                                <div class="cell cell-ebookmodulename">
                                    <div class="cell-wrapper">
                                        <div class="cell-heading"> {{ i18n.t("label_chapter")}}</div>
                                        <div class="cell-content">{{module.ebookmodulename }}</div>
                                    </div>
                                </div>
                                <div class="cell cell-publisher">
                                    <div class="cell-wrapper">
                                        <div class="cell-heading">{{ i18n.t("label_publisher")}}</div>
                                        <div class="cell-content"><img :src="appendAccessToken(book.publisher.publishernamesmalllogo)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, inject}  from "vue";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {useBookList} from "@/modules/home/booklist";
    import FooterHome from "@/views/footer/FooterHome";
    import HeaderHome from "@/views/header/HeaderHome";
    import config from "@/config/config.json";
    import cssvar from '@/scss/_variables.scss';
    import {appendAccessToken} from  "@/modules/utils/pathUtils";

    export default {

        setup(props, context) {

            const {booklistState, isShowBookEntry, isShowModule, getEbookCoverURL} = useBookList();
            const i18n = inject('i18n');

            const ebooklist = computed(()=>{
                return JSON.parse(localStorage.ebooklist);
            });

            return {
                i18n,
                ebooklist,
                isShowBookEntry,
                isShowModule,
                getEbookCoverURL,
                appendAccessToken
            }
        }
    }

</script>

<style scoped lang="scss">

    //to option panel border

    $cell-padding:10px;
    $cell-padding-narrow:6px;

    @mixin listing-border($side) {
        border-#{$side}:1px solid $border-color-lighter;
    }

    .listing {
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;;
        @include listing-border(left);
        @include listing-border(right);
        color:$text-color-primary;
    }

    .heading {
        display: flex;
        width:100%;
        background:$grey-light;

        .cell {
            font-weight:400;
        }
    }

    #book-list-container {
        max-width: 1024px;
        margin: $header-height auto;
        position:relative;
        z-index:$zindex-home-container;
    }

    .row {
        width: 100%;
        display: flex;
        color:#000;
        @include listing-border(bottom);
        @include transition(all, 0.2s);
    }

    .cell-heading {
        display: none;
    }

    .cell-thumb {
        flex:0 0 100px;
        img {
            width: calc(100% - #{$cell-padding})
        }
    }

    .main-meta-wrapper {
        flex-grow: 1;
        display:flex;
        flex:1;
    }

    .cell {
        box-sizing: border-box;
        padding:$cell-padding;
    }

    .cell-ebookseriesname {
        width:30%;
    }

    .cell-ebookname {
        width:15%;
    }

    .cell-ebookmodulename {
        width:30%;
    }

    .cell-publisher {
        width:25%;

        img {
            width:100%;
            max-width:200px;
        }
    }


    .cell-content a {
        color:$color-primary;

        &:hover {
            color:$color-primary-bright;
        }
    }

    @include responsive(tablet) {
        #book-list-container {
            max-width:none !important;
        }
    }

    @include responsive(mobile-large) {
        .listing {
            display: block;
            width: 100%;
            box-shadow: none;
        }

        .cell-wrapper {
            width:100%;
        }

        .cell {
            width: 100% !important;
            display: flex;
            align-items: center;
            padding: $cell-padding-narrow $cell-padding-narrow $cell-padding-narrow 0;
        }

        .cell-thumb {
            flex: 0 0 100px;
            align-items: flex-start;
            padding: $cell-padding-narrow 0 $cell-padding-narrow $cell-padding-narrow !important;
        }


        .heading {
            display: none;
        }

        .cell-heading {
            display:block;
            margin:0 10px 0 0;
            font-weight:400;
            flex:0.3
        }

        .cell-content {
            display:block;
            flex:1;
        }

        .cell-wrapper {
            display:flex;
        }

        .main-meta-wrapper {
            display:block;
        }
    }
</style>